import { render, staticRenderFns } from "./RepositoryUploadComponentOld.vue?vue&type=template&id=31471c62&"
import script from "./RepositoryUploadComponentOld.vue?vue&type=script&lang=js&"
export * from "./RepositoryUploadComponentOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports